import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { Logout } from 'acscp/actions';
import { AppState } from 'acscp/store';
import { FormattedMessage } from 'react-intl';

interface LogoutButtonDispatchProps {
    logout: () => void;
}

export class LogoutButtonPresentational
        extends PresentationComponentBase<{}, {}, LogoutButtonDispatchProps, {}> {

    render(): JSX.Element {
        return (
            <a href="javascript:;" onClick={this.props.logout}>
                <FormattedMessage
                    id={'components.auth.logoutButton.signOut'}
                    defaultMessage={'Sign Out'}
                />
            </a>
        );
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): LogoutButtonDispatchProps {
    return {
        logout: () => dispatch(new Logout())
    };
}

export const LogoutButton = connect(undefined, mapDispatchToProps)(LogoutButtonPresentational);
